import React, { FunctionComponent, useEffect, useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Box from "@material-ui/core/Box";
import { useConfigStyles } from "../configStyles";
import { useStore } from "../../../store";
import { PosConfigurationTableList } from "./PosConfigurationList/PosConfigurationTableList";
import { PosConfiguration } from "./PosConfigurationList/PosConfiguration";
import { Helmet } from "react-helmet-async";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};

export const PosConfigurationMaster = () => {
  const classes = useConfigStyles();
  const [value, setValue] = React.useState(0);
  const [editData, setEditData] = useState<object>({});
  const [editFlag, setEditFlag] = useState<boolean>(false);
  const [viewPosConfigPermission, setViewPosConfigPermission] = useState<
    boolean
  >(false);
  const [editPosConfigPermission, setEditPosConfigPermission] = useState<
    boolean
  >(false);
  const [addPosConfigPermission, setAddPosConfigPermission] = useState<boolean>(
    false
  );

  const [posConfigurations] = useStore("posConfigurations");
  const [user] = useStore("auth", "user");

  useEffect(() => {
    const posConfigPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 13
    );
    if (user.is_super_admin === true) {
      setAddPosConfigPermission(true);
      setEditPosConfigPermission(true);
      setViewPosConfigPermission(true);
    } else {
      if (posConfigPermission) {
        if (posConfigPermission.is_add === true) {
          setAddPosConfigPermission(true);
        }
        if (posConfigPermission.is_view === true) {
          setViewPosConfigPermission(true);
        }
        if (posConfigPermission.is_edit === true) {
          setEditPosConfigPermission(true);
        }
        if (posConfigPermission.is_view === false) {
          setValue(1);
          setViewPosConfigPermission(false);
        }
        if (
          posConfigPermission.is_add === false &&
          posConfigPermission.is_edit === false &&
          posConfigPermission.is_view === false
        ) {
          setAddPosConfigPermission(false);
          setEditPosConfigPermission(false);
          setViewPosConfigPermission(false);
        }
      }
    }
  });

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setEditFlag(false);
  };

  const goToEdit = (id: number) => {
    const editRow =
      posConfigurations &&
      posConfigurations.find((i: any) => i.config_id === id);
    setEditData(editRow);
    setEditFlag(true);
    setValue(1);
  };

  const goBackToList = () => {
    setValue(0);
    setEditFlag(false);
  };

  return (
    <>
      <Helmet>
        <title>Pos configuration</title>
      </Helmet>
      <Grid
        container
        spacing={2}
        direction="row"
        justify="space-between"
        alignItems="center"
      >
        <Grid item xs={12} className={classes.root}>
          <AppBar position="static">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
            >
              <Tab
                label="POS Configurations List"
                style={{ display: viewPosConfigPermission ? "" : "none" }}
              />
              {editFlag === false ? (
                <Tab
                  label="Add POS Configurations"
                  style={{ display: addPosConfigPermission ? "" : "none" }}
                />
              ) : (
                <Tab
                  label="Edit POS Configurations"
                  style={{ display: editPosConfigPermission ? "" : "none" }}
                  disabled
                />
              )}
            </Tabs>
          </AppBar>

          <TabPanel value={value} index={0}>
            <Grid
              container
              spacing={2}
              direction="row"
              justify="space-between"
              alignItems="center"
            >
              {viewPosConfigPermission ? (
                <Grid item xs={12}>
                  <PosConfigurationTableList
                    posConfigurations={posConfigurations}
                    goToEdit={goToEdit}
                    editPosConfigPermission={editPosConfigPermission}
                  />
                </Grid>
              ) : null}
            </Grid>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <PosConfiguration
              editFlag={editFlag}
              editData={editData}
              goBackToList={goBackToList}
            />
          </TabPanel>
        </Grid>
      </Grid>
    </>
  );
};
